import { render, staticRenderFns } from "./addNameModal.vue?vue&type=template&id=65c161cc&scoped=true"
import script from "./addNameModal.vue?vue&type=script&lang=js"
export * from "./addNameModal.vue?vue&type=script&lang=js"
import style0 from "./addNameModal.vue?vue&type=style&index=0&id=65c161cc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c161cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Maintenance projects\\devConfig-web-project\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65c161cc')) {
      api.createRecord('65c161cc', component.options)
    } else {
      api.reload('65c161cc', component.options)
    }
    module.hot.accept("./addNameModal.vue?vue&type=template&id=65c161cc&scoped=true", function () {
      api.rerender('65c161cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/openConfig/addNameModal.vue"
export default component.exports